import {
  getBlackFairId,
  getMegaFairId,
  isBlackFairActive,
  isMegaFairActive,
} from '@/modern/utils/fairs'
import { createUrlPhotoAd, floatToCurrency } from './utils'

function handlePrice({ price = '' }) {
  return `R$ ${price ? floatToCurrency(price, 0) : '0'}`
}

function handleYear({ yearFabrication, yearModel }) {
  let year = ''
  if (yearFabrication) {
    year = yearModel ? `${yearFabrication}/${yearModel}` : yearFabrication
  }
  return year
}

function handleTravelledDistance({ odometer }) {
  return `${odometer ? floatToCurrency(odometer, 0) : '0'} Km`
}

export function handleLocation({ city = '', state = '' }) {
  const stateCode = state.split(' ').pop().replace(/[()]/g, '')
  return `${city} - ${stateCode}`
}

function handleAttributes({ vehicleAttributes }) {
  return vehicleAttributes.length
    ? vehicleAttributes.map(attribute => attribute.Name)
    : []
}

function isMegaFairAd({ fairs, hotDeal }) {
  const { hasMegaFair, megaFair } = fairs
  const isHotDeal = hotDeal && hotDeal.length > 0
  return (
    isHotDeal &&
    isMegaFairActive(hasMegaFair) &&
    hotDeal.some(item => +item.Id === getMegaFairId(hasMegaFair, megaFair))
  )
}

function isBlackFairAd({ fairs, hotDeal }) {
  const { hasBlackFair, blackFair } = fairs
  const isHotDeal = hotDeal && hotDeal.length > 0
  return (
    isHotDeal &&
    isBlackFairActive(hasBlackFair) &&
    hotDeal.some(item => +item.Id === getBlackFairId(hasBlackFair, blackFair))
  )
}

function handleHotDeal({ fairs, hotDeal }) {
  const feiroes = {
    blackFeirao: false,
    megaFeirao: false,
    ofertaDestaque: false,
  }

  if (!hotDeal || hotDeal.length === 0) return feiroes

  hotDeal.forEach(item => {
    if (!item.Value) return

    if (isBlackFairAd({ fairs, hotDeal })) {
      feiroes.blackFeirao = true
    } else if (isMegaFairAd({ fairs, hotDeal })) {
      feiroes.megaFeirao = true
    } else {
      feiroes.ofertaDestaque = true
    }
  })

  return feiroes
}

function handlePhotos({ photos, vehicleType, listingType }) {
  return photos.map(photo => {
    if (!photo.PhotoPath) return ''
    return createUrlPhotoAd(
      photo.PhotoPath,
      vehicleType,
      listingType || undefined
    )
  })
}
export const handleSearchData = ({
  searchResult,
  href = '',
  fairs,
  vehicleType,
}) => {
  const {
    UniqueId = 0,
    HotDeal = [],
    ListingType = '',
    Specification: {
      Make = { Value: '' },
      Model = { Value: '' },
      Version = { Value: '' },
      YearFabrication = '',
      YearModel = '',
      Odometer = '',
      Color = { Primary: '' },
      VehicleAttributes = [],
    } = {},
    Prices: { Price = '' },
    Seller: {
      AdType = { Value: '' },
      City = '',
      State = '',
      ExceededPlan = false,
      // stamps
      CarDelivery = false,
      TrocaComTroco = false,
      DealerScore = 0,
    } = {},
    Media: { Photos = [] } = {},
    // stamps
    IsElegible360View = false,
    GoodDeal = false,
    VipAutopago = false,
    MediaZeroKm = false,
    AdvertisementLink = ''
  } = searchResult
  

  return {
    id: UniqueId,
    make: Make.Value,
    model: Model.Value,
    version: Version.Value,
    versionId: Version.id,
    color: Color.Primary,
    price: handlePrice({ price: Price }),
    year: handleYear({
      yearFabrication: YearFabrication,
      yearModel: YearModel,
    }),
    travelledDistance: handleTravelledDistance({ odometer: Odometer }),
    location: handleLocation({ city: City, state: State }),
    wasSold: false,
    wasFavorited: false,
    attributes: handleAttributes({ vehicleAttributes: VehicleAttributes }),
    stamps: {
      autopago: VipAutopago,
      superPreco: GoodDeal,
      feiroes: handleHotDeal({ fairs, hotDeal: HotDeal }),
      sellerBadges: DealerScore > 0,
      carDelivery: CarDelivery,
      trocaComTroco: TrocaComTroco,
      isElegible360View: IsElegible360View,
    },
    seller: AdType.Value,
    photos: handlePhotos({
      photos: Photos,
      vehicleType,
      listingType: ListingType,
    }),
    href,
    type: vehicleType,
    exceededLimit: ExceededPlan,
    mediaZeroKm: MediaZeroKm,
    advertisementLink: AdvertisementLink
  }
}
